import type { Dossier } from '@wizbii/utils/models';

import { createAction, props } from '@ngrx/store';

export const DossierGet = createAction('[Dossier] Get', props<{ redirectUrl?: string[] }>());
export const DossierGetSuccess = createAction(
  '[Dossier] Get Success',
  props<{ dossiers: Dossier[]; redirectUrl?: string[] }>()
);
